import React, { useEffect, useState } from 'react'
import AppModal from '../../../components/organisms/CustomModal'
import PageTitle from 'components/atoms/PageTitle'
import FormInput from 'components/atoms/FormInput'
import { connect, useSelector } from 'react-redux'
import { setUserLoggedIn } from 'redux/auth/auth.action'
import { BASE_URL, getRequest, loggedUser_baseURL, putRequest } from 'services/http'
import Alert from 'components/atoms/Alert'
import Button from 'components/atoms/Button'
import KYCForms from "modules/kycForms";
import { KYCDocList } from '../../../modules/kycDocList';
import addIcon from '../../../assets/svg/blue_add.svg';

const EditKYCinfo = (props) => {
    const [loading, setLoading] = useState(false);
    const [addField, setAddField] = useState(false);
    const [kycDocList, setKycDocList] = useState<any>([]);
    const [kycDocuments, setKYCDocuments] = React.useState(null);
    const [errorStatus, setErrorStatus] = useState(false);
    // const [fields, setFields] = useState(null);
    const [field, setField] = useState(null)
    const [value, setValue] = useState<any>([]);
    const [bvnIdErr, setBvnIdErr] = useState('');
    const [address, setAddress] = useState('');
    const [city, setCity] = useState('');
    const [state, setState] = useState('');
    const [country, setCountry] = useState('');
    const [formData, setFormData] = useState<any>({});

    const bearerToken = useSelector((state: any) => state.auth.user_authData?.token.token);

    const updateKYCInfo = async (requestData: any) => {
        setLoading(true);
        const headers = {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${props.bearerToken}`
        }
        const res = await putRequest(`${BASE_URL + loggedUser_baseURL}update`, headers, requestData);

        if (res?.data.responseCode === '00') {
            Alert('success', res?.data.message);
            setLoading(false);
            props.setShowModal(false);
        } else {
            setLoading(false);
        }
    }

    const handleSubmit = e => {
        e.preventDefault();

        if (address !== '' || city !== '' || state !== '') {
            if (value.length === kycDocList.length) {
                updateKYCInfo({
                    address: {
                        street: address,
                        city: city,
                        state: state,
                    },
                    kycDoc: value
                })
            } else {
                return Alert("warning", `Please add all required files`);
            }
        } else {
            return Alert("warning", `Please fill all required fields`);
        }
    }

    const removeFieldHandler = () => {
        if(value.length === 4){
            setValue(value.filter(item => item.required === true));
        }
    }

    const kycDocListFunc = () => {
        let kycDocs = KYCDocList.filter(item => item.required === true);
        setKycDocList(kycDocs);

        return kycDocs;
    }

    useEffect(() => {
        kycDocListFunc();
    }, [])

    const addFieldHandler = () => {
        setKycDocList(KYCDocList);
        setAddField(true);
    }

    return (
        <AppModal
            handleClose={() => props.setShowModal(false)}
            modalStyle="max-w-sm w-full mobile:w-4/5 bg-white min-h-[300px] h-fit z-30 my-auto mx-auto left-0 right-0 animate-slide_up rounded-lg p-8 shadow-[0_8px_30px_rgb(0,0,0,0.12)] transition-all"
            contentStyle=""
            closeBtnStyle='hidden'
        >
            <form onSubmit={handleSubmit} className='flex flex-col gap-5'>
                <PageTitle
                    pageTitle='Enter KYC Information'
                    pageTitleStyle='font-semibold !text-2xl tablet:!text-xl'
                    subTitle='Upload business documents'
                    subTitleStyle='!text-sm leading-7 !text-Black2'
                />

                <div className='flex flex-col gap-3'>
                    <span className='font-semibold text-sm'>
                        <span className='!text-[10px]'>Required</span>
                        <span style={{ color: 'rgb(255 34 0)' }} className='font-16'>*</span>
                    </span>
                    <div className='flex flex-col'>
                        <FormInput
                            type={'text'}
                            name='address'
                            placeholder={`${address === '' && props.authData?.address?.street === undefined ? 'Street' : props.authData?.address?.street}`}
                            style='w-full'
                            inputStyle="border border-transparent text-Black2"
                            required={true}
                            label="Address"
                            labelStyle="font-semibold text-sm leading-6 text-Black2"
                            value={address}
                            onChange={(e) => setAddress(e.target.value)}
                        />

                        <div className='flex justify-between items-center gap-5'>
                            <FormInput
                                type={'text'}
                                name='city'
                                placeholder={`${city === '' && props.authData?.address?.city === undefined ? 'City' : props.authData?.address?.city}`}
                                style='w-full'
                                inputStyle="border border-transparent text-Black2"
                                required={true}
                                label="City"
                                labelStyle="font-semibold text-sm leading-6 text-Black2"
                                value={city}
                                onChange={(e) => setCity(e.target.value)}
                            />
                            <FormInput
                                type={'text'}
                                name='state'
                                placeholder={`${state === '' && props.authData?.address?.state === undefined ? 'State' : props.authData?.address?.state}`}
                                style='w-full'
                                inputStyle="border border-transparent text-Black2"
                                required={true}
                                label="State/Province"
                                labelStyle="font-semibold text-sm leading-6 text-Black2"
                                value={state}
                                onChange={(e) => setState(e.target.value)}
                            />
                        </div>
                    </div>

                    <div className='flex flex-col'>
                        {kycDocList && kycDocList.map((item: any, i) => (
                            <KYCForms
                                key={i}
                                field={field}
                                setField={setField}
                                data={item}
                                value={value}
                                required={item.required}
                                handleValue={(e) => {
                                    setValue({ ...value, [e.target.name]: e.target.value });
                                }}
                                setValue={setValue}
                                kycDocuments={kycDocuments}
                                setKYCDocuments={setKYCDocuments}
                                addField={addField}
                                setAddField={setAddField}
                                handleRemoveAddedField={kycDocListFunc}
                                removeFieldHandler={removeFieldHandler}
                            />
                        ))}
                        {!addField &&
                            <div className='flex  justify-between items-center gap-5 my-2'>
                                <p className='text-BackDrop_d_md text-xs'>Click to add another Director's valid ID</p>
                                <Button
                                    btnType='submit'
                                    btnText='Add'
                                    btnStyle={`cursor-pointer hover:!shadow-none text-Accent_blue font-normal text-[15px] !flex-row-reverse leading-5 w-fit !gap-2`}
                                    btnImg={addIcon}
                                    btnImgStyle='w-5 h-5'
                                    onClick={addFieldHandler}
                                />
                            </div>}
                    </div>
                    <span className='font-normal text-xs text-BackDrop_d_xl'>Accepted file formats include <b>pdf, ppt, docx, jpg, jpeg and png</b></span>
                </div>

                <div className='flex justify-between'>
                    <Button
                        btnType='button'
                        btnText='Close'
                        btnStyle='text-Primary bg-none border-none'
                        onClick={() => props.setShowModal(false)}
                    />
                    <Button
                        btnType="submit"
                        btnText={
                            loading ? (
                                "Loading..."
                            ) : (
                                "Submit"
                            )
                        }
                        btnStyle={`${value.length < 1 ? "cursor-not-allowed" : ""
                            } bg-black text-white px-6 py-3 w-fit`}
                        onClick={() => { }}
                    />
                </div>
            </form>
        </AppModal>
    )
}

const mapStateToProps = state => ({
    bearerToken: state.auth.user_authData?.token.token,
    authData: state.auth.user_authData,
    user_loggedIn: state.auth.user_loggedIn,
})

const mapDispatchToProps = dispatch => ({
    setUserLoggedIn: (data: boolean) => dispatch(setUserLoggedIn(data)),
})

export default connect(mapStateToProps, mapDispatchToProps)(EditKYCinfo);

